import React from "react";
import cx from "classnames";

import Modal from "./Modal";
import ModalSection from "./ModalSection";
// eslint-disable-next-line import/no-cycle
import ModalHeader from "./ModalHeader";

import "./styles/style.scss";

const ModalFooter = ({ className, ...other }) => (
  <ModalSection className={cx("modal-dialog__footer", className)} {...other} />
);
ModalFooter.displayName = "ModalFooter";

export { ModalSection, ModalHeader, ModalFooter };

export default Modal;
